import InlineRename from './InlineTextEdit.vue';

export default InlineRename;
